import {createContext} from 'react';

export type ThemeName = 'theme-legacy' | 'theme-light'

export const ThemeContext = createContext<ThemeName>('theme-legacy');
